<!-- My Profile -->
<div class="row justify-content-center m-0">
    <div class="col-lg-8">

        <!-- Profile details -->
        <mat-card *ngIf="service.myProfile" class="mt-3 mb-4">
            <mat-card-content>
                <div class="row">

                    <!-- Change profile image -->
                    <div class="col-3  p-3 text-center">
                        <img class="full-width" vlink="image.png" [cache]="false" [model]="service.myProfile" [alt]="service.myProfile.name">
                         <label for="image-change">
                            <a mat-raised-button color="primary" >{{'PROFILE.CHANGE_IMAGE' | translate }}</a>
                        </label>

                        <!-- Upload image -->
                        <input id="image-change" type="file" (change)="uploadFile($event)" placeholder=" {{'PROFILE.UPLOAD.FILE' | translate }}" accept=".png,.jpg,.jpeg" hidden="true">
                    </div>
                    <div class="col-9">

                        <!-- Profile details -->
                        <mat-tab-group>
                            <mat-tab label=" {{ 'PROFILE.DETAILS' | translate }}">
                                <div class="m-3">
                                    <div qmap-question [model]="service.myProfile" *ngFor="let qm of fields" [qMap]="qm" ></div>
                                </div>
                                <!-- Profile name / save profile -->
                                <div class="text-right">
                                    <button mat-raised-button color="primary" (click)="changeName()">
                                        {{'PROFILE.SAVE' | translate }}</button>
                                </div>
                            </mat-tab>

                            <!-- Profile password -->
                            <mat-tab label=" {{ 'PROFILE.PASSWORD' | translate }}">
                                <br/>
                                <div *ngIf="!pload" >
                                <div   qmap-validator #passwordCheck="qmap-validator">

                                    <!-- Old password -->
                                    <div qmap-question [model]="password" [qMap]="{id:'oldp',type:'shorttext',style:'password',title: 'PROFILE.OLD_PASSWORD' | translate}"></div>
                                    
                                    <!-- New password -->
                                    <div qmap-question [model]="password" [qMap]="{id:'newp',type:'shorttext',style:'password',title: 'PROFILE.NEW_PASSWORD' | translate,required:true}"></div>
                                    
                                    <!-- Confirm password -->
                                    <div qmap-question [model]="password" [qMap]="{id:'newp2',type:'shorttext',style:'password',title: 'PROFILE.VERIFY_PASSWORD' | translate,required:true}"></div>
                                </div>

                                <!-- Change password -->
                               <div class="text-right">
                                    <button [disabled]="!passwordCheck?.valid || pload" mat-raised-button color="primary" (click)="setpass()">{{'PROFILE.CHANGE_PASSWORD' | translate }}</button>
                                </div>
                            </div>
                            </mat-tab>
                        </mat-tab-group>                     
                    </div>
                </div>
            </mat-card-content>
            <mat-card-actions>
               
                
            </mat-card-actions>
        </mat-card>

    </div>
</div>

<div *ngIf="loading">
    <div class="loading">
        <mat-spinner color="accent"></mat-spinner>
    </div>
</div>